var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.5h-6.334a.5.5 0 0 1 0-1h6.333a.5.5 0 0 1 0 1Z",
    fill: "#363740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14a.5.5 0 0 1-.353-.854l2.146-2.148-2.146-2.146a.5.5 0 1 1 .707-.707l2.5 2.5a.5.5 0 0 1 0 .707l-2.5 2.5a.497.497 0 0 1-.354.147ZM9.333 20c-.142 0-.278-.02-.413-.062l-4.012-1.337c-.546-.19-.908-.699-.908-1.268v-12C4 4.598 4.598 4 5.333 4c.143 0 .278.02.414.062l4.012 1.337c.546.19.908.699.908 1.268v12c0 .735-.598 1.333-1.334 1.333Zm-4-15A.334.334 0 0 0 5 5.333v12c0 .142.095.274.231.322l3.994 1.33c.028.01.066.015.108.015.184 0 .334-.15.334-.333v-12a.346.346 0 0 0-.232-.322l-3.993-1.33A.362.362 0 0 0 5.333 5Z",
    fill: "#363740"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 9.333a.5.5 0 0 1-.5-.5v-3A.834.834 0 0 0 12.834 5h-7.5a.5.5 0 0 1 0-1h7.5c1.011 0 1.833.822 1.833 1.833v3a.5.5 0 0 1-.5.5ZM12.833 18h-2.667a.5.5 0 0 1 0-1h2.667c.46 0 .833-.374.833-.833v-3a.5.5 0 0 1 1 0v3A1.835 1.835 0 0 1 12.833 18Z",
    fill: "#363740"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.86fdf0bcd1e23434c64dedd79841fe5a.svg";
export { ForwardRef as ReactComponent };